import React, { createContext, useState } from "react";

/** @type ShowTextContextType */
const defaultContextValue = {
    getShowFullText: (_group) => false,
    toggleShowFullText: (_group) => {}
};

export const DataGrid2Context = createContext(defaultContextValue);

export function DataGrid2Provider({ children }) {
    const [showFullTextMap, setShowFullTextMap] = useState({ all: false });
    const getShowFullText = (group) => showFullTextMap[group || "all"] || false;
    const toggleShowFullText = (group) => {
        const key = group || "all";
        setShowFullTextMap(currentMap => ({ ...currentMap, [key]: !currentMap[key] }));
    };
    return (
        <DataGrid2Context.Provider value={{ getShowFullText, toggleShowFullText }}>
            {children}
        </DataGrid2Context.Provider>
    );
}